import { Component, Input } from '@angular/core';
import { NoteService } from '../../core/services/note.service';
import { TicketRightPanelService } from '../../core/services/ticket-right-panel.service';
import { DetailedTicketDTO } from '../../core/models/dto/detailed-ticket.dto';
import { NgStyle } from '@angular/common';
import { NewNoteComponent } from '../../shared/components/new-note/new-note.component';

@Component({
    selector: 'app-reply-note',
    templateUrl: './add-reply-note.component.html',
    styleUrls: ['./add-reply-note.component.scss'],
    imports: [NgStyle, NewNoteComponent],
})
export class AddReplyNoteComponent {
    @Input() ticket: DetailedTicketDTO;

    constructor(
        public noteService: NoteService,
        public ticketRightPanelService: TicketRightPanelService,
    ) {}

    onCloseEditor() {
        this.noteService.isEditorForNewNoteShown = false;
    }

    onNoteAdd(response) {
        this.noteService.addNewNote(response);

        this.noteService.noteIdWithMentionedUser = response.id;
        this.noteService.ignoreParamNoteId = true;
        this.noteService.disableNoteHighlighting = false;

        this.noteService.openNotes(this.ticket);

        this.noteService.isEditorForNewNoteShown = false;
    }
}
